import { PlaceChangeAsWork } from 'app/constants/configuration/placeChangeAsWork'

export const getPlaceChangeAsWorkName = (
  placeChangeAsWork: PlaceChangeAsWork,
  translate: (string) => string,
): string => {
  const text: string = PlaceChangeAsWork[placeChangeAsWork]
  return translate(`placeChangeAsWork.${text}`)
}
